module.exports = __webpack_public_path__ + "nc_static/media/menu-extend-arrow.81dab228.svg";